"use client"

import { WorkScopePhotoSlot } from "@/features/photos/api/photos.api"

const SLOT_LABEL: Record<WorkScopePhotoSlot, string> = {
  before: "Before",
  after: "After",
}

export default function WorkScopeCompleteBadge({
  workScopeName,
  slot,
}: {
  workScopeName: string
  slot: WorkScopePhotoSlot
}) {
  const label = `${SLOT_LABEL[slot]} picture for ${workScopeName}`
  return (
    <span
      title={label}
      aria-label={label}
      className="absolute left-1.5 top-1.5 z-10 inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground shadow"
    >
      {SLOT_LABEL[slot] === "Before" ? "B" : "A"}
    </span>
  )
}
